export const popups = {
  registerRequest: {
    title: 'Domanda di registrazione',
    description: 'Compila il questionario e ti contatteremo.',
    button: 'Lascia una domanda di registrazione',
    form: {
      noteLabel: 'Come hai imparato su di noi?',
      notePlaceholder: 'Come hai imparato su di noi?',
      checkboxExperience: 'Sono con esperienza nel club',
      club: {
        nameLabel: 'Il nome del club',
        namePlaceholder: 'Il nome del club'
      }
    }
  },
  invite: {
    title: 'Conferma età',
    description: 'Hai 18 anni? Conferma la tua età per usare la piattaforma.',
    confirm: 'Sì, ho 18 anni'
  },
  deleteAccount: {
    title: 'Vuoi davvero eliminare un account?',
    subTitle: 'Sarà impossibile annullare la rimozione.',
    description:
      'Invece di rimozione, il profilo può essere nascosto. Non sarà disponibile per nessuno tranne te fino a quando non decidi di aprirlo.'
  },
  exitFromProfile: {
    title: 'Disconnettersi?',
    description: 'Conferma che vuoi disconnetterti.'
  },
  hideAccount: {
    title: 'Nascondi profilo?',
    description:
      'Il tuo profilo non sarà visibile a nessuno tranne te finché non deciderai di riaprirlo.'
  },
  mainPhoto: {
    title: 'Immagine di copertina',
    description: "Scegli un'immagine di copertina per il tuo CV"
  },
  updateVideo: {
    title: 'Caricamento video',
    description: 'Attendi il caricamento del video'
  },
  consumation: {
    title: 'Consumazione',
    description:
      "Inserisci le 5 posizioni più popolari dalla consumo quanto ogni posizione e percentuale del prezzo per i pagamenti ai costi dell'artista."
  },
  crazyMenu: {
    title: 'Menu pazzo',
    description:
      'Inserisci le 5 posizioni più popolari dal menu folle e il costo di ciascuno.'
  },
  warningOnCloseOnboarding: {
    title: 'Sei sicuro?',
    description:
      'Sei sicuro di voler interrompere la compilazione? Il tuo portfolio non verrà pubblicato. I club non potranno inviarti le migliori offerte. Potrai riprendere più tardi.'
  },
  foreignLanguage: {
    title: 'Livello di competenza'
  },
  createWorkItem: {
    title: 'Conferma invito',
    titleRequest: 'Conferma richiesta',
    inviteDescription:
      'Questa informazione è presunta. Puoi discuterne in una chiacchierata con un artista e aggiornare il suo invito',
    requestDescription:
      "Questa informazione è presunta. Puoi discuterne in una chat con un club e aggiornare l'applicazione",
    suggestVacancy: "Offri un posto vacante per l'artista",
    selectVacancy: 'Indicare il posto vacante di interesse',
    ticketCreditOption: 'La possibilità di prestare un biglietto',
    ticketCreditRequired: 'Ho bisogno di un prestito per biglietti?'
  },
  clubWorkInteraction: {
    artistWorkAtClub: "L'artista lavora nel tuo club.",
    setLastDay: {
      title: 'Impostare ultimo giorno di lavoro?',
      setLastWorkDate:
        "Indicare la data dell'ultimo giorno lavorativo dell'artista",
      description:
        "Avendo fissato l'ultima data per l'artista, non può essere cambiato. Dopo la data del set, l'artista completerà il contratto nel tuo club."
    },
    artistArrival: {
      title: "Conferma la presenza dell'artista?",
      description: "Confermi la presenza dell'artista nel tuo club",
      information:
        "Il lavoro inizierà dal momento in cui confermi la presenza dell'artista sul posto di lavoro."
    },
    workCancel: {
      title: 'Annullare il contratto?',
      description: 'Confermi la cancellazione del contratto'
    },
    wantEndDate: {
      title: "L'artista vuole ottenere l'ultima data."
    },
    newEndDate: {
      title: 'Ultimo giorno di lavoro'
    }
  },
  artistWorkInteraction: {
    manageCurentContract: {
      pendingLastWorkDateRequest:
        'La tua richiesta per il completamento del contratto è in esame.',
      workStartOnArtistArrivalConfirm:
        'Il lavoro inizierà dal momento in cui il club conferma la tua presenza sul posto di lavoro.',
      weCanRequestLastWorkDate:
        'Richiedi la data di fine contratto al club.',
      clubSetLastWorkDate:
        'Il club ha fissato la tua ultima data di lavoro in questo club.'
    }
  },
  changeProfile: {
    title: 'I miei club'
  },
  confirmOnboardingCompletion: {
    title: 'Il tuo portafoglio è pubblicato',
    description: 'Ora i club potranno invitarti a lavorare'
  },
  videoUploading: {
    title: 'Caricamento video',
    description: 'Attendi il caricamento del video'
  },
  addWorkItem: {
    title: 'Luogo di lavoro',
    vacancyQuestion: 'Per quali posti vacanti hai lavorato?',
    validationMessage: 'Hai già stabilito che stai lavorando al tempo attuale.'
  },
  selectMainPhoto: {
    title: 'La foto principale',
    description: 'Specifica una foto della copertina per il tuo curriculum'
  },
  deleteWorkExperience: {
    title: 'Eliminare?',
    description: 'Sei sicuro di voler eliminare questa esperienza lavorativa?'
  }
};
